import React, { useEffect, useState } from "react";
import { Award, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { API_BASE } from "@/lib/api";

export const CertificatesPage = () => {
  const [certs, setCerts] = useState([]);
  useEffect(() => { api.get("/certificates").then((r) => setCerts(r.data || [])); }, []);

  const download = async (id) => {
    const token = localStorage.getItem("fi_token");
    const res = await fetch(`${API_BASE}/certificates/${id}/download`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `funded-index-certificate.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6" data-testid="certificates-page">
      <div>
        <h1 className="font-display text-3xl font-bold">Certificates</h1>
        <p className="text-[#8a8a8a] text-sm mt-1">Your achievements, certified.</p>
      </div>
      {certs.length === 0 ? (
        <div className="glass rounded-xl p-10 text-center">
          <Award className="mx-auto text-[#ff7a00]" size={36} />
          <div className="font-display text-xl font-semibold mt-4">No certificates yet</div>
          <p className="text-[#8a8a8a] text-sm mt-2">Pass an evaluation challenge to earn your first certificate.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {certs.map((c) => (
            <div key={c.id} className="glass rounded-xl p-6" data-testid={`cert-${c.id}`}>
              <div className="flex items-start justify-between">
                <Award className="text-[#ff7a00]" size={28} />
                <div className="text-[10px] text-[#8a8a8a] font-mono">#{c.certificate_number}</div>
              </div>
              <div className="font-display text-xl font-bold mt-4">{c.achievement_title}</div>
              <div className="text-[#ff9a2f] font-display text-2xl font-bold mt-2">${c.account_size.toLocaleString()}</div>
              <div className="text-xs text-[#8a8a8a] mt-2">Issued {new Date(c.issued_at).toLocaleDateString()}</div>
              <Button onClick={() => download(c.id)} className="w-full mt-5 bg-[#ff7a00] hover:bg-[#ff9a2f] text-[#050505] font-semibold" data-testid={`cert-download-${c.id}`}>
                <Download size={16} className="mr-2" /> Download PDF
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
